import { DataGrid } from "@mui/x-data-grid";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

const ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 25, 50, 100];

const StructuresDataGrid = memo(
  ({ data, loading, columns, paginationProps }) => {
    const { t } = useTranslation();

    const localeText = useMemo(
      () => ({
        noRowsLabel: t("teams.teamProfile.NoRows"),
        MuiTablePagination: {
          labelRowsPerPage: t("teams.teamProfile.RowsPerPage")
        }
      }),
      [t]
    );

    return (
      <DataGrid
        autoHeight
        rows={data}
        loading={loading}
        columns={columns}
        rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
        density="comfortable"
        getRowId={row => row.id}
        disableColumnMenu
        disableSelectionOnClick
        pagination
        {...paginationProps}
        localeText={localeText}
      />
    );
  }
);

StructuresDataGrid.displayName = "StructuresDataGrid";

export default StructuresDataGrid;
